import {type StyleProp, type ViewStyle} from 'react-native'
import Svg, {Path} from 'react-native-svg'

export type IconProps = {
  size: number
  style?: StyleProp<ViewStyle>
  color?: string
}

export default function ExpandRightIcon(props: IconProps) {
  const {size, style, color = 'currentColor'} = props
  return (
    <Svg viewBox="0 0 28 28" width={size} height={size} style={[style]}>
      <Path
        d="M18.375 11.1126L13.0247 5.76231C12.6964 5.43418 12.2512 5.24989 11.7871 5.25C11.3229 5.25011 10.8778 5.4346 10.5496 5.7629C10.2215 6.09119 10.0372 6.53639 10.0373 7.00056C10.0374 7.46473 10.2219 7.90984 10.5502 8.23798L15.9005 13.5871C15.9549 13.6413 15.998 13.7057 16.0274 13.7766C16.0568 13.8474 16.0719 13.9234 16.0719 14.0001C16.0719 14.0769 16.0568 14.1529 16.0274 14.2237C15.998 14.2946 15.9549 14.359 15.9005 14.4131L10.5502 19.7623C10.2219 20.0905 10.0374 20.5356 10.0373 20.9997C10.0372 21.4639 10.2215 21.9091 10.5496 22.2374C10.8778 22.5657 11.3229 22.7502 11.7871 22.7503C12.2512 22.7504 12.6964 22.5661 13.0247 22.238L18.375 16.8876C19.1395 16.1211 19.5688 15.0827 19.5688 14.0001C19.5688 12.9176 19.1395 11.8792 18.375 11.1126Z"
        fill={color}
      />
    </Svg>
  )
}
